<template lang="pug">
.dashboard-card

  .section-header
    .section-title
      h2 🎂 Cumpleaños de hoy
  //- CONTENEDOR QUE CONTROLA EL SCROLL INFINITO
  .birthday-scroll(
    ref="birthdayScroll"
    @scroll.passive="handleScroll"
  )
    //- CARGA INICIAL
    .initial-loading(
      v-if="isLoading && lista.length === 0"
    )
      .loader
      span Cargando cumpleaños...
    //- NO HAY REGISTROS
    .empty-state(
      v-else-if="!isLoading && lista.length === 0"
    )
      .empty-circle
        span 🎂
      .empty-info
        strong Sin cumpleaños hoy
        p No existen colaboradores cumpliendo años.
    //- HAY REGISTROS
    template(v-else)
      .birthday(
        v-for="o in lista"
        :key="o.id"
      )
        .birthday-avatar
          img(
            :src="o.pathFoto"
            @error="imagenDefault"
          )
        .birthday-info
          strong {{ o.nombre }}
          span {{ o.nombreArea }}
      //- CARGANDO SIGUIENTE BLOQUE
      .scroll-loading(v-if="isScroll")
        .loader.loader-small
        span Cargando más cumpleaños...
      //- FIN DEL LISTADO
      .scroll-end(
        v-if="noMore && lista.length > 0"
      )
        span No hay más cumpleaños
</template>
<script>
import { apiGet, notify }  from '../../../util/general'
import moment from 'moment';
export default {
  name: 'CumpleaniosHoy',
  data () {
    return {
      lista                                 : [],
      mes                                   : moment().month() + 1,
      isLoading                             : false,
      disabledScrollExecute                 : false,
      noMore                                : false,
      isScroll                              : false,
      skip                                  : 0
    }
  },
  mounted () {
    this.obtenerNuevoEmpleado(false)
  },
  methods: {
    handleScroll (event) {
      var element = event.target
      if (this.isLoading || this.isScroll || this.noMore || this.disabledScrollExecute) {
        return
      }
      var scrollTop = element.scrollTop
      var scrollHeight = element.scrollHeight
      var clientHeight = element.clientHeight
      /*
       * Carga cuando faltan aproximadamente
       * 80px para llegar al final.
       */
      var distanciaFinal = scrollHeight - (scrollTop + clientHeight)
      if (distanciaFinal <= 80) {
        this.obtenerNuevoEmpleado(true)
      }
    },
    obtenerNuevoEmpleado (esScroll) {
      var vm = this
      if (vm.noMore || vm.disabledScrollExecute) {
        return
      }
      vm.disabledScrollExecute = true
      if (esScroll) {
        vm.isScroll = true
      } else {
        vm.isLoading = true
      }
      var obj = {
        mes: vm.mes,
        skip: vm.skip
      }
      apiGet(vm, '/empleado/cumpleanios', obj, function (data) {
        console.log('data.lista >>>>>>', data.lista)
        var lista = data && data.lista ? data.lista : []
        for (var i = 0; i < lista.length; i++) {
          if (data.lista[i].esCumpleanios) {
            vm.lista.push(data.lista[i])
          }
        }
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExecute = true
        } else {
          vm.skip += data.skip
          vm.disabledScrollExecute = false
        }
      }, function (error) {
        vm.disabledScrollExecute = false
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isScroll = false
        vm.isLoading = false
      })
    },
    imagenDefault (event) {
      event.target.src = '/img/avatar-default.png'
    }
  }
}
</script>
<style scoped>
.dashboard-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}
.section-header {
  padding: 11px 21px;
  border-bottom: 1px solid #eff0f2;
}
.section-title h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #292d32;
}
.section-title p {
  margin: 4px 0 0;
  font-size: 12px;
  color: #8b9097;
}
.empty-state {
  min-height: 245px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 25px;
}
.empty-circle {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #faf4e9;
}
.empty-info {
  display: flex;
  flex-direction: column;
}
.empty-info strong {
  font-size: 12px;
  color: #484d52;
}
.empty-info p {
  margin: 4px 0 0;
  font-size: 11px;
  color: #969ba1;
}
/* ==========================================
   CUMPLEAÑOS
   ========================================== */
.birthday {
  min-height: 72px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f0f1f3;
  transition: background .15s ease;
}
.birthday:last-child {
  border-bottom: 0;
}
.birthday:hover {
  background: #faf9fa;
}
/* AVATAR */
.birthday-avatar {
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #faf1e5;
  color: #a66b1f;
  font-size: 11px;
  font-weight: 700;
}
/* INFORMACIÓN */
.birthday-info {
  flex: 1;
  min-width: 0;
  margin-left: 13px;
  display: flex;
  flex-direction: column;
}
.birthday-info strong {
  font-size: 11px;
  font-weight: 600;
  color: #34383d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.birthday-info span {
  margin-top: 3px;
  font-size: 10px;
  color: #858a90;
}
</style>



// WEBPACK FOOTER //
// c_cumpleanios_hoy.vue?b284571e